/**
 * @generated SignedSource<<24ec6d45d4549f474475897fdcd6d9bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CountrySidebar_country$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
  readonly " $fragmentType": "CountrySidebar_country";
};
export type CountrySidebar_country$key = {
  readonly " $data"?: CountrySidebar_country$data;
  readonly " $fragmentSpreads": FragmentRefs<"CountrySidebar_country">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CountrySidebar_country",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntitySidebar_entity"
    }
  ],
  "type": "Country",
  "abstractKey": null
};

(node as any).hash = "ab0e243d460f138c68ccf0869da88099";

export default node;
